/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pilot_How_KickerInputs */



/**
* | output |
* | --- |
* | "How it works" |
*
* @param {Onboarding_Pilot_How_KickerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_how_kicker = /** @type {((inputs?: Onboarding_Pilot_How_KickerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_How_KickerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Hoe het werkt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comment ça marche")
	return /** @type {LocalizedString} */ ("How it works")
});